import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import * as superjson from "superjson";

export const noanAsyncStorageKey = "NOAN_OFFLINE_CACHE";
export const noanAsyncStorageCacheBuster = "1";

export function createNoanAsyncStoragePersister() {
  return createAsyncStoragePersister({
    key: noanAsyncStorageKey,
    storage: localStorage,
    throttleTime: 1000,
    serialize: superjson.stringify,
    deserialize: superjson.parse,
  });
}

export function purgeNoanAsyncStorage() {
  if (typeof window.localStorage !== "undefined") {
    window.localStorage.removeItem(noanAsyncStorageKey);
    console.warn(`!! Purged asyncStorage: ${noanAsyncStorageKey}`);
  }
}
